module.exports = __webpack_public_path__ + "static/media/collapseIcon.efaac59c.svg";